

































































































import Vue from "vue";
import storeHelper from "../../store/store-helper";
import { ContentItemDetails } from "@/types/contentItemDetails";
import { ContentItem, ContentItemFieldValue } from "@infoland/iprova-api";

export default Vue.extend({
    name: "NavDrawerContentItemDetails",
    components: {},
    props: {
        item: Object as () => ContentItem,
        portalId: Number
    },
    data: function () {
        return {
            drawerRight: true,
            currentContentItemDetails: {
                contentItemTitle: null,
                contentItemId: null,
                contentTypeSingularName: null
            },
            contentItemDetailsList: [] as ContentItemFieldValue[],
            isContentItemDetailsSkeletonVisible: false
        };
    },
    watch: {
        item: function (newVal) {
            this.openContentItemDetails(newVal);
        },
        drawerRight: function (newVal) {
            if (newVal === false) {
                this.$emit("close-drawer");
            }
        }
    },
    computed: {
        mdAndDown(): boolean {
            return this.$vuetify.breakpoint.mdAndDown;
        },
        lgAndUp(): boolean {
            return this.$vuetify.breakpoint.lgAndUp;
        }
    },
    created() {
        this.openContentItemDetails(this.item);
    },
    methods: {
        async openContentItemDetails(item: ContentItem) {
            this.isContentItemDetailsSkeletonVisible = true;
            if (this.currentContentItemDetails.contentItemId !== item.content_item_id) {
                this.currentContentItemDetails = {
                    contentItemId: item.content_item_id,
                    contentItemTitle: item.title,
                    contentTypeSingularName: item.content_type?.singular_name
                };
                const contentItemDetails = {
                    portalId: this.portalId,
                    contentItemId: item.content_item_id
                } as ContentItemDetails;
                this.contentItemDetailsList = await storeHelper.contentItemsStore.loadContentItemDetailsAsync(contentItemDetails);
                this.contentItemDetailsList = this.contentItemDetailsList.filter(cid => cid.value && cid.value !== "-");
            }
            this.isContentItemDetailsSkeletonVisible = false;
        },
        followContentItemClick() {
            this.$emit("open-content-item", this.item);
        },
        getOpenContentItemIconLabel(currentContentItemDetails) {
            return this.$t("portal.portals.contentItemDetails.goToContentItem") + " " + currentContentItemDetails.contentTypeSingularName;
        },
        isComplianceField(fieldId: string) {
            return fieldId === "48";
        }
    }
});
